import type { FaireProductEntity } from "../../entity_types/product";

export const p_3bqc66q5f2: FaireProductEntity = {
  token: "p_3bqc66q5f2",
  type: "product",
  name: "Sea Glass Salt Bar - Ocean Fresh Sea Salt Exfoliating Spa Soap",
  brandName: "Evolve Botanica",
  imageUrl:
    "https://cdn.faire.com/fastly/85a498fd9760c4de9d4a8b916a32f96d75bbeb8b7b13b35d27f1a66be63a9bf7.jpeg",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/baf310bfab10ba6801aba555b916cc7060bb72f538b4eb497b0f8543051e74c5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
